import React, { useState } from "react";
import { getConnectInboxCsvErrorLabel } from "./constants";

const i = n => `${n} ${n === 1 ? "inbox" : "inboxes"}`;

// Content rendered inside confirmationPopupState's slide-down popup (dynamicDom: true) after a
// synchronous bulk-CSV connect finishes - mirrors Components/common/AddToSequenceResultBody.js's
// "View more" pattern, keyed by row email instead of a reason key, since each row's message is
// its own (not grouped/counted like add-to-sequence failures).
const BulkCsvResultBody = ({ successCount = 0, failedCount = 0, failedRows = [] }) => {
  const [showMore, setShowMore] = useState(false);

  if (failedCount === 0) {
    return <div>All inboxes are connected successfully.</div>;
  }

  const headline =
    successCount === 0
      ? `Failed to connect all inboxes. `
      : `${i(successCount)} connected successfully. Failed to connect ${i(failedCount)}. `;

  return (
    // Headline + "View more" stay centered like every other confirmationPopup message (no
    // special wrapper needed - .linkHighLight/.failureResponseMsg/.leftBorder are already styled
    // generically by main.scss's `.confirmation-popup .popup-wrap .popup-content-wrap` rule).
    // Only the expanded per-row list is forced left via inline style, since its text-align:left
    // override otherwise lives behind a `.retryResponse` scope that we don't want on the headline.
    <div>
      <span>{headline}</span>
      <span className="linkHighLight" onClick={() => setShowMore(!showMore)}>
        {showMore ? "View less" : "View more"}
      </span>
      {showMore && (
        <div className="failureResponseMsg" style={{ textAlign: "left" }}>
          <div className="leftBorder" />
          {failedRows.map(row => (
            <div key={row.email}>{`${row.email} — ${getConnectInboxCsvErrorLabel(row)}`}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BulkCsvResultBody;
export { BulkCsvResultBody };
